import React from "react";
import Song from "../../components/song/song";
import { getData } from "./music-list-fn";

import "./music-list.scss";

var allSongs = getData();

function MusicList() {
    return (
        <div className="music-list">
            <div className="all-songs">
                {allSongs.map((song) =>
                    <Song song={song} key={song.id} />
                )}
            </div>
        </div>
    );
}

export default MusicList;
